/**
 * Locale-aware ISO timestamp → human string. Previously duplicated across
 * three route files (`users/Detail`, `matches/Detail`, `audit/List`).
 *
 * Returns the raw input when the timestamp is malformed rather than throwing
 * — admin screens would rather render a weird string than blank a whole row.
 */

export function formatDateTime(iso: string): string {
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleString();
  } catch {
    return iso;
  }
}

/**
 * Date-only variant for admin list views (Users list, Questions list).
 */
export function formatDate(iso: string): string {
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString();
  } catch {
    return iso;
  }
}

/**
 * Wall-clock seconds/minutes between two ISO timestamps. Used by the
 * Matches list duration column and the Match detail rounds section.
 */
export function formatDuration(startIso: string, endIso: string | null): string {
  if (!endIso) return '—';
  const start = new Date(startIso).getTime();
  const end = new Date(endIso).getTime();
  if (!Number.isFinite(start) || !Number.isFinite(end) || end < start) {
    return '—';
  }
  const secs = Math.round((end - start) / 1000);
  const m = Math.floor(secs / 60);
  const s = secs % 60;
  return m > 0 ? `${m}m ${s}s` : `${s}s`;
}
